import React from 'react';
import { useSelector } from 'react-redux';
import { configTableSelector } from '@store/errorLogicConfig/base/selectors';
import { ERROR_LOGIC_MODE_CONFIG } from '@utils/constants';
import { Retry } from '@components/common';
import ConfigTable from './ConfigTable';
import LogTable from './LogTable';

function ErrorLogicTable() {
  const mode = useSelector(configTableSelector);
  let table = <Retry isLoading showError={false} />;

  if (mode === ERROR_LOGIC_MODE_CONFIG) {
    table = <ConfigTable />;
  } else {
    table = <LogTable />;
  }
  return table;
}

export default ErrorLogicTable;
